import { LANG } from '../index';

// 分销商看到的 订单状态（非分销） （已弃用
const AFFILIATE_ORDER_MAP = {
  1: { title: LANG['state.affiliate_order._x1'] }, // 已支付
  2: { title: LANG['state.affiliate_order._x2'] }, // 已完结
  3: { title: LANG['state.affiliate_order._x3'] }, // 已关闭
  4: { title: LANG['state.affiliate_order._x4'] }, // 已退款
};

// 分销商提现订单状态，具体逻辑参考：https://arashivision.feishu.cn/wiki/wikcnoap8xhk0vJ2IwmlubAvK2b
export const WITHDRAW_STATE_MAP = {
  '0': {
    title: LANG['state.withdraw._0'], // 未审核 (运营后台：待审核)
    color: '#009bf7',
    tagStyle: {
      color: ' #262629',
      background: '#F8F9FC',
    },
  },
  '1': {
    title: LANG['state.withdraw.order_unavailable'], // 未可提现
    color: '#999999',
    tagStyle: {
      color: ' #262629',
      background: '#F8F9FC',
    },
  },
  '3': {
    title: LANG['state.withdraw.order_available'], // 可提现
    color: '#333',
    tagStyle: {
      color: ' #1BC864',
      background: '#1BC8641A',
    },
  },
  '4': {
    title: LANG['state.withdraw.order_process'], // 处理中(运营后台：待支付)
    color: '#e28e38',
    tagStyle: {
      color: ' #262629',
      background: '#F8F9FC',
    },
  },
  '9': {
    title: LANG['state.withdraw.order_success'], // 已提现
    color: '#00c96a',
    icon: 'https://res.insta360.com/static/4b482ec96701cf24eb8b80fb7c6a695a/Component%202.svg',
    tagStyle: {
      color: ' #1BC864',
      background: 'transparent',
    },
  },
  '-1': {
    title: LANG['state.withdraw.order_rejected'], // 已拒绝
    color: '#e21623',
    tagStyle: {
      color: '#262629',
      background: '#F8F9FC',
    },
  },
  '-2': {
    title: LANG['state.withdraw.order_unable_withdraw'], // 已申请退款，映射为不可提现
    color: '#e21623',
    tagStyle: {
      color: ' #262629',
      background: '#F8F9FC',
    },
  },
  '-3': {
    title: LANG['state.withdraw.order_unable_withdraw'], // 分销状态已关闭的订单映射为不可提现 仅供显示而不可作为业务使用
    color: '#666',
    tagStyle: {
      color: ' #262629',
      background: '#F8F9FC',
    },
  },
};

// 分销提现流程状态 对应运营后台分销订单流程状态
export const WITHDRAW_PROCESS_STATE_MAP = {
  '-1': {
    title: LANG['state.withdraw.order_rejected'],
    tagStyle: {
      color: '#262629',
      background: '#F8F9FC',
    },
  },
  '0': {
    title: LANG['state.withdraw._0'],
    tagStyle: {
      color: '#262629',
      background: '#F8F9FC',
    },
  },
  '1': {
    title: LANG['state.withdraw._1'],
    tagStyle: {
      color: '#262629',
      background: '#F8F9FC',
    },
  },
  '9': {
    title: LANG['state.withdraw._9'],
    icon: 'https://res.insta360.com/static/4b482ec96701cf24eb8b80fb7c6a695a/Component%202.svg',
    tagStyle: {
      color: '#1BC864',
      background: 'transparent',
    },
  },
};

// 订单状态
const ORDER_STATE_MAP = {
  '0': {
    desc: '待付款',
    title: LANG['state.order._0'],
  },
  '1': {
    desc: '已支付',
    title: LANG['state.order._1'],
  },
  '2': {
    desc: '处理中', // 配货中
    title: LANG['state.order._2'],
  },
  '3': {
    desc: '已发货',
    title: LANG['state.order._3'],
  },
  '4': {
    desc: '部分发货',
    title: LANG['state.order._4'],
  },
  '6': {
    desc: '支付处理中 - 支付异常（后台状态）',
    title: LANG['state.order._6'],
  },
  '7': {
    // 客服反馈已不再使用
    desc: '申请退货中（状态已到订单子项）',
    title: LANG['state.order._7'],
  },
  '8': {
    // 客服反馈已不再使用
    desc: '申请退款中（状态已到订单子项）',
    title: LANG['state.order._8'],
  },
  '9': {
    desc: '已完成',
    title: LANG['state.order._9'],
  },
  '-1': {
    // 订单超过7天自动取消，foter失败自动取消
    desc: '已取消',
    title: LANG['state.order._x1'],
  },
  '-2': {
    // 客服反馈已不再使用
    desc: '已退款（状态已到订单子项）',
    title: LANG['state.order._x2'],
  },
  '-3': {
    // 客服反馈已不再使用
    desc: '已退货（状态已到订单子项）',
    title: LANG['state.order._x3'],
  },
  '-4': {
    // 只有后台手动改到这个状态
    desc: '已关闭',
    title: LANG['state.order._x4'],
  },
  '-5': {
    desc: '拒付',
    title: LANG['state.order._x5'],
  },
};

// 订单子产品状态
export const ORDER_ITEM_STATE_MAP = {
  'allow_refund_return': {
    title_temp: '申请退款',
    title: '售后申请',
    key: 'allow_refund_return',
  },
  'allow_refund': {
    title_temp: '申请退款',
    title: LANG['state.order.sub.allow_refund'],
    key: 'allow_refund',
  },
  'allow_return_or_change': {
    title_temp: '申请退换货',
    title: LANG['state.order.sub.allow_return_or_change'],
    key: 'allow_return_or_change',
  },
  '0': {
    title_temp: '默认状态',
    title: '默认状态',
    key: 'normal',
  },
  '1': {
    title_temp: '退货中', // 退货申请正在处理中
    title: LANG['state.order.sub._1_refundInProgress'],
    key: 'returning',
  },
  '2': {
    title_temp: '退款中', // 退款申请正在处理中
    title: LANG['state.order.sub._2_refundInProgress'],
    key: 'refunding',
  },
  '3': {
    title_temp: '换货中', // 换货申请正在处理中
    title: LANG['state.order.sub._3_refundInProgress'],
    key: 'changing',
  },
  '9': {
    title_temp: '已完成',
    title: LANG['state.order.sub._9'],
    key: 'changing',
  },
  '-1': {
    title_temp: '已退款',
    title: LANG['state.order.sub._x1'],
    key: 'refunded',
  },
  '-2': {
    title_temp: '已退货',
    title: LANG['state.order.sub._x2'],
    key: 'returned',
  },
  '-3': {
    title_temp: '已换货',
    title: LANG['state.order.sub._x3'],

    key: 'changed',
  },
  '-9': {
    title_temp: '已关闭',
    title: LANG['state.order.sub._x9'],
    key: 'closed',
  },
};

// rma 类型
export const RMA_TYPE_MAP = {
  'rma_cancel': {
    title_temp: '取消订单',
    title: LANG['order.rma.type.cancel'],
  },
  'rma_change': {
    title_temp: '申请换货',
    title: LANG['order.rma.type.change'],
  },
  'rma_return': {
    title_temp: '申请退货',
    title: LANG['order.rma.type.return'],
  },
  'rma_refund': {
    title_temp: '申请退款',
    title: LANG['order.rma.type.refund'],
  },
};

// 可显示订单追踪状态
const TRACK_ORDER_STATES = [3, 4, 9];
// 不可显示订单操作状态
const ORDER_NOT_OPERATION_STATES = [-4, -1, 0];
// 订单未支付
const ORDER_NOT_PAID = [0, -1, 6];

function getOrderStateTitle(state) {
  try {
    return ORDER_STATE_MAP[state + '']['title'];
  } catch (e) {
    return '-';
  }
}

// 不能退款，退货，换货的商品显示状态
function getOrderItemStateTitle(item) {
  const { state: item_state } = item;
  if (item_state === 0) return '';
  const tmp = ORDER_ITEM_STATE_MAP[item_state + ''];
  return tmp ? tmp.title : '';
}

// 套餐状态
const SALE_STATE_MAP = {
  '-3': '即将上架',
  '-2': '下架',
  '-1': '缺货',
  '0': '选购',
  '1': '预售',
  '2': '预定',
  '即将上架': -3,
  '下架': -2,
  '缺货': -1,
  '选购': 0,
  '预售': 1,
  '预定': 2,
};

// 订单状态MAP
const ORDER_STATE = {
  '未支付': 0,
  '0': '未支付',
  '1': '已支付',
  '已支付': 1,
  '2': '处理中', // 配货中
  '处理中': 2,
  '3': '已发货',
  '已发货': 3,
  '4': '部分发货',
  '部分发货': 4,
  '6': '支付处理中',
  '支付处理中': 6,
  '7': '申请退货中',
  '申请退货中': 7,
  '8': '申请退款中',
  '申请退款中': 8,
  '9': '已完成',
  '已完成': 9,
  '-1': '已取消',
  '已取消': -1,
  '-2': '已退款',
  '已退款': -2,
  '-3': '已退货',
  '已退货': -3,
  '-4': '已关闭',
  '已关闭': -4,
  '-5': '拒付',
  '拒付': -5,
};

export {
  getOrderItemStateTitle,
  getOrderStateTitle,
  TRACK_ORDER_STATES,
  ORDER_NOT_OPERATION_STATES,
  AFFILIATE_ORDER_MAP,
  ORDER_STATE_MAP,
  SALE_STATE_MAP,
  ORDER_STATE,
  ORDER_NOT_PAID,
};
